<template> 
    <div class="convo-item" :class="{convoLive: conversation.liveCall, convoItemSelected: conversation.selected}" @click="$emit('convoClicked')">
      <div class='sidebarAvatar'>
        <div class='imgWrap'>
          <img v-if='conversation.latestInteractionAvatar' class="sidebarHandlerImg" :src='conversation.latestInteractionAvatar'>
          <label v-else-if='conversation.latestInteractionName'>{{ getInitials(conversation.latestInteractionName) }}</label>
          <img v-else class="sidebarHandlerImg" src='//assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_unknown.jpg'>
        </div>
        <div class='callStatus' :class="{live: conversation.liveCall, unaddressed: conversation.unaddressed}">
          <i class='zmdi zmdi-circle'  v-if="conversation.liveCall"></i>
          <i class='zmdi zmdi-phone' v-else-if='conversation.icon == "phone"'></i>
          <i class='zmdi zmdi-voicemail' v-else-if='conversation.icon == "voicemail"'></i>
          <i class='zmdi zmdi-comment-edit' v-else-if='conversation.icon == "edit"'></i>
          <i class='zmdi zmdi-comment-text' v-else></i>
        </div>
      </div>
      <div class="convo-text" :title='conversation.liveCall ? !conversation.sneak:conversation.sneak'>
        <div class='convo-meta'>
          <label :class='{sub : !mobileView}'>{{formatNumberAlt(conversation.name)}}</label>
          <div :class="{disclaimer: !mobileView}">{{conversation.displayTime}}</div>
        </div>
        <div class="convo-sneak" :class='{disclaimer : !mobileView}'v-if="conversation.liveCall">
          {{conversation.tlInfo}}
        </div>
        <div :id='conversation.interactionid' class="convo-sneak" :class='{disclaimer : !mobileView}' v-else>
          <label :class="{sub: mobileView, small: !mobileView}">{{conversation.type}}:</label>
          <div class='sneak'>{{conversation.sneak}}</div>
          <label :class="{sub: mobileView, small: !mobileView}" v-if='conversation.attachment && conversation.attachmentType == "image"'>(Attachment: 1 Image)</label>
          <label :class="{sub: mobileView, small: !mobileView}" v-if='conversation.attachment && conversation.attachmentType == "video"'>(Attachment: 1 Video)</label>
        </div>
      </div>
      <i v-if="!conversation.liveCall && conversation.unaddressedConvo" class="zmdi zmdi-dot-circle-alt unaddressedIcon"></i>
    </div>
</template>
<script>
	export default {
        name: 'sideBarItem',
        props: ['conversation', 'mobileView'],
        methods:{
		    formatNumberAlt: function (number) {
		      var cleaned = ('' + number).replace(/\D/g, '');
		      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
		      if (match) {
		        return match[1] + '-' + match[2] + '-' + match[3];
		      }
		      return number;
		    },
		    getInitials: function (name) {
		      let nameArray = name.trim().split(' ');
		      let initials = '';
		      
		      if (nameArray.length === 2) {
		        initials += nameArray[0][0];
		        initials += nameArray[1][0];
		      } else if (nameArray.length > 2) {
		        initials += nameArray[0][0];
		        initials += nameArray[nameArray.length-1][0];
		      } else if (nameArray.length === 1) {
		        initials += nameArray[0][0];
		      }
		      return initials;
	    	}
        }
    }
</script>